import { render } from "./UnNFTsNavigationMobile.vue?vue&type=template&id=5f98dfd6&scoped=true"
import script from "./UnNFTsNavigationMobile.vue?vue&type=script&lang=js"
export * from "./UnNFTsNavigationMobile.vue?vue&type=script&lang=js"

import "./UnNFTsNavigationMobile.vue?vue&type=style&index=0&id=5f98dfd6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f98dfd6"]])

export default __exports__